import Parse from 'html-react-parser';

function BMP20194(props) {
    let svgCode =
    `<svg width="1384" height="156" viewBox="0 0 1384 156" fill="none" xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
    .boxStyle rect {
        ${props.boxStyle}
    }
    .paramBoxStyle {
        ${props.boxStyle}
    }
    ${props.fontFace}
    </style>
        <rect width="1384" height="156" fill="${props.backgroundFill}" stroke="${props.outlineColour}" stroke-width="5"/>
        <circle cx="270" cy="63.4546" r="36" fill="${props.paramFill}"/>
        <rect x="267.818" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="238.551" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 238.551 91.8182)" fill="${props.paramFill}"/>
        <rect x="295.091" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 295.091 91.6312)" fill="${props.paramFill}"/>
        <circle cx="390" cy="63.4546" r="36" fill="${props.paramFill}"/>
        <rect x="387.818" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="358.551" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 358.551 91.8182)" fill="${props.paramFill}"/>
        <rect x="415.091" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 415.091 91.6312)" fill="${props.paramFill}"/>
        <circle cx="770" cy="63.4546" r="36" fill="${props.paramFill}"/>
        <rect x="767.818" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="738.551" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 738.551 91.8182)" fill="${props.paramFill}"/>
        <rect x="795.091" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 795.091 91.6312)" fill="${props.paramFill}"/>
        <circle cx="1110" cy="63.4546" r="36" fill="${props.paramFill}"/>
        <rect x="1107.82" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="1078.55" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 1078.55 91.8182)" fill="${props.paramFill}"/>
        <rect x="1135.09" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 1135.09 91.6312)" fill="${props.paramFill}"/>
        <circle cx="1250" cy="63.4546" r="36" fill="${props.paramFill}"/>
        <rect x="1247.82" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="1218.55" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 1218.55 91.8182)" fill="${props.paramFill}"/>
        <rect x="1275.09" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 1275.09 91.6312)" fill="${props.paramFill}"/>
        <path class="paramBoxStyle" d="M0 54H175C177.761 54 180 56.2386 180 59V97C180 99.7614 177.761 102 175 102H0V54Z" fill="#C0AB0F"/>
        <path class="paramBoxStyle" d="M876 54H1023C1025.76 54 1028 56.2386 1028 59V97C1028 99.7614 1025.76 102 1023 102H876V54Z" fill="#C0AB0F"/>
        <g class="boxStyle">
        <rect x="214" y="110" width="230" height="28" rx="4" fill="${props.paramFill}"/>
        <rect x="574" y="110" width="110" height="28" rx="4" fill="${props.paramFill}"/>
        <rect x="593" y="46" width="74" height="40" rx="5" fill="${props.paramFill}"/>
        <rect x="716" y="110" width="106" height="28" rx="4" fill="${props.paramFill}"/>
        <rect x="1054" y="110" width="110" height="28" rx="4" fill="${props.paramFill}"/>
        <rect x="1196" y="110" width="106" height="28" rx="4" fill="${props.paramFill}"/>
        </g>
        <g letter-spacing="${props.fontExtras.space}" font-weight="${props.fontExtras.weight}" fill="${props.fontColour}" font-family="${props.fontName}">
        <text fill="black" font-size="27"><tspan x="13" y="88.2285">HYPER</tspan></text>
        <text font-size="16"><tspan x="250" y="129.969">RATE</tspan></text>
        <text font-size="16"><tspan x="357" y="129.969">DETUNE</tspan></text>
        <text font-size="16"><tspan x="495" y="129.969">RETRIG</tspan></text>
        <text font-size="16"><tspan x="598" y="129.969">UNISON</tspan></text>
        <text font-size="16"><tspan x="754" y="129.969">MIX</tspan></text>
        <text font-size="16"><tspan x="1234" y="129.969">MIX</tspan></text>
        <text font-size="16"><tspan x="1093" y="129.969">SIZE</tspan></text>
        <text fill="black" font-size="27"><tspan x="894" y="88.2285">DIMENSION</tspan></text>
        </g>
        <path d="M159 78L167.66 68.25H150.34L159 78Z" fill="black"/>
    </svg>`

    props.svgReturn(95, svgCode, "bmp00194", 1384, 156);

    return (
        Parse(svgCode)
    );
}

export default BMP20194;